/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Photo_AddInputs */



/**
* | output |
* | --- |
* | "Add photo" |
*
* @param {Settings_Photo_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_photo_add = /** @type {((inputs?: Settings_Photo_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Photo_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Foto toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une photo")
	return /** @type {LocalizedString} */ ("Add photo")
});